// extracted by mini-css-extract-plugin
module.exports = {"clock":"styles_clock__9qiyp","left":"styles_left__1H4oV","right":"styles_right__Plq1R","progress":"styles_progress__1qU64","box":"styles_box__3G3Gf"};